import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CitiesService {

  constructor(private http: HttpClient) { }

  private url = environment.apiUrl;

  getCities(): Observable<any> {
    return this.http.get<any>(`${this.url}/api/city`);
  }

  getCitySurbubs(cityId: number): Observable<any> {
    return this.http.get<any>(`${this.url}/api/city/${cityId}/suburbs`);
  }
}
